import { useState, useEffect } from 'react';
import { LandingCarousel, useStore } from '../../../../../store';
import { editLandingCarouselTESTReq } from 'application/api';
import { useGetLandingCarousel } from './useGetLandingCarousel';
import { useEditLandingCarousel } from './useEditLandingCarousel';

/**
 * Custom hook to handle carousel state and actions
 * @returns carousels from the back-end, with one default carousel
 */
export const useCarousels = () => {
  const { landingCarousels, loading, error, refetch } = useGetLandingCarousel(true);
  const { editCarousels, loading: editLoading, error: editError } = useEditLandingCarousel();
  const [curCarousels, setCurCarousels] = useState<Array<LandingCarousel>>([]);
  const dispatchSetAlert = useStore((state) => state.dispatchSetAlert);

  const submitCarouselChanges = async (newArray: Array<LandingCarousel>) => {
    // Ensure order numbers are correctly set based on current array order
    const carouselsWithCorrectOrder = newArray.map((c, index) => ({
      ...c,
      orderNum: index
    }));
    
    const apiReadyCarousels: editLandingCarouselTESTReq = carouselsWithCorrectOrder.map((c) => ({
      id: c.id,
      image: c.image,
      link: c.link,
      hide: c.isHidden ? 1 : 0,
      button_text: c.buttonText,
      headline: c.headerText,
      subhead: c.subHeaderText,
      orderNum: c.orderNum
    }));
    console.log('apiReadyCarousels', apiReadyCarousels);
    
    // Use the new direct API approach
    const result = await editCarousels(carouselsWithCorrectOrder);
    
    if (result.success) {
      // Refetch the carousels after successful edit
      await refetch(true);
      
      // Show success alert to user
      dispatchSetAlert({
        status: 'success',
        header: 'Success',
        text: 'Successfully updated carousels'
      });
    } else {
      // Handle error case - show error alert to user
      console.error('Failed to update carousels:', result.message);
      
      dispatchSetAlert({
        status: 'danger',
        header: 'Error',
        text: result.message || 'Failed to update carousels'
      });
    }
  };
  
  // Update curCarousels when landingCarousels from API changes
  useEffect(() => {
    setCurCarousels(landingCarousels);
  }, [landingCarousels]);

  return { 
    curCarousels, 
    setCurCarousels, 
    submitCarouselChanges,
    loading: loading || editLoading, // Combined loading state
    error: error || editError, // Combined error state
    refetch
  };
};
